module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_March2020-83111bbe1ac10e7b6a7eb37951b77f53.pdf";